import { ActionTypes } from '../../actions/constants';

export const initialState = {};

// This redux store will have key:values of searchResultId: { seen: bool, dataLoaded: bool }
export default function searchAnalyticsReducer(state = initialState, action = {}) {
    const searchResultId = action.payload && action.payload.searchResultId;
    switch (action.type) {
        case ActionTypes.TRACK_TIMESGRID_DATA_LOADED:
            return {
                ...state,
                [searchResultId]: state[searchResultId] ?
                    {
                        ...state[searchResultId],
                        dataLoaded: true,
                    } :
                    {
                        seen: false,
                        dataLoaded: true,
                    },
            };
        case ActionTypes.TRACK_SEARCH_SCROLLED_TO_RESULT:
            return {
                ...state,
                [searchResultId]: state[searchResultId] ?
                    {
                        ...state[searchResultId],
                        seen: true,
                    } :
                    {
                        seen: true,
                        dataLoaded: false,
                    },
            };
        default:
            return state;
    }
}
